// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyC_cJlWTUoXr1XrEGo4Yx5ZbvuJojmi9t8",
    authDomain: "nizzykicks-51796.firebaseapp.com",
    projectId: "nizzykicks-51796",
    storageBucket: "nizzykicks-51796.appspot.com",
    messagingSenderId: "729807792585",
    appId: "1:729807792585:web:0d0b60db06514b79dae018",
    measurementId: "G-XBEMJQZSKX"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
